import { RouteObject } from "react-router";
import { ROUTE_PATH } from "../constants";
import {
  Auth,
  Curating,
  Help,
  Journal,
  Main,
  Notification,
  Plans,
  PlansView,
  LessonView,
  Profile,
  Report,
  Restore,
  Schedule,
  JournalCurrent,
  TestView,
  PrintJournal,
  Test,
  Rup,
  QualificationRup,
  TableRup,
  JournalSdot,
  StudentSchedule,
  ScheduleStudentPlan,
  ScheduleStudentTest,
  Record,
  ScheduleStudentTestView,
  JournalSdotTestView,
  EntrantRegister,
  ProfessionalOrientationTest,
  EntrantApplicationPage,
  EntrantAdmissionWithoutRanking,
  AdmissionAcceptRejectNote, AdmissionNotes, AdmissionView,
  UserApplications, UserApplicationsCurrent, AdmissionLog, EducationOrders, EntrantInfo, LeaveUserOrder,
  Library, LibraryCurrentView, JournalInnerPage, MedicalRoom, Exam
} from "../pages";
import { DefaultProtectedLayout, ProtectedLayout, PublicLayout, RootLayout } from "../layout";
import { store } from "../store";
import { resetCommon } from "../store/common/actions";
import { resetJournal } from "../store/pages/journal/actions";
import { resetPlan } from "../store/pages/plans/actions";
import { AppealsView } from "../pages/MedicalRoom/AppealsView/[id]";
import { PsychologistRoom } from "../pages/Psychologist";
import { PsychologistView } from "../pages/Psychologist/[id]";
import { PsychologistWorkSubView } from "../pages/Psychologist/WorkSubtab/[id]";


const protectedRoutesArr: RouteObject[] = [
  {
    element: <ProtectedLayout />,
    children: [
      {
        path: ROUTE_PATH.MAIN,
        element: <Main />,
      },
      {
        path: ROUTE_PATH.NOTIFICATION,
        element: <Notification />,
      },
      {
        path: ROUTE_PATH.HELP,
        element: <Help />,
      },
      {
        path: ROUTE_PATH.REPORT,
        element: <Report />,
      },
      {
        path: ROUTE_PATH.LIBRARY,
        children: [
          {
            element: <Library />,
            index: true,
          },
          {
            path: ROUTE_PATH.LIBRARY_CURRENT,
            children: [
              {
                element: <LibraryCurrentView />,
                index: true,
              },
              {
                path: ROUTE_PATH.LIBRARY_CURRENT_TEST,
                children: [
                  {
                    element: <Test />,
                    index: true
                  },
                  {
                    path: ROUTE_PATH.LIBRARY_CURRENT_TEST_VIEW,
                    element: <TestView />
                  }
                ]
              }
            ]
          },
        ]
      },
      {
        path: ROUTE_PATH.CURATING,
        element: <Curating />,
      },
      {
        path: ROUTE_PATH.PROFILE,
        element: <Profile />,
      },
      {
        path: ROUTE_PATH.PRINT_JOURNAL,
        element: <PrintJournal />,
      },
      {
        path: ROUTE_PATH.EXAM,
        children: [
          {
            element: <Exam />,
            index: true,
          },
          {
            path: ROUTE_PATH.EXAM_PLAN,
            children: [
              {
                element: <ScheduleStudentPlan />,
                index: true,
              },
            ]
          },
        ],
      },
      {
        path: ROUTE_PATH.JOURNAL,
        children: [
          {
            element: <Journal />,
            loader: () => {
              store.dispatch(resetCommon())
              store.dispatch(resetPlan())
              return false
            },
            index: true,
          },
          {
            path: ROUTE_PATH.JOURNAL_CURRENT,
            children: [
              {
                element: <JournalCurrent />,
                loader: () => {
                  store.dispatch(resetCommon())
                  store.dispatch(resetPlan())
                  store.dispatch(resetJournal())
                  return false
                },
                index: true,
              },
              {
                path: ROUTE_PATH.JOURNAL_CURRENT_INNER,
                children: [
                  {
                    element: <JournalInnerPage />,
                    index: true,
                  },
                ]
              }
            ]
          },
          {
            path: ROUTE_PATH.JOURNAL_SDOT,
            children: [
              {
                element: <JournalSdot />,
                index: true,
              },
              {
                path: ROUTE_PATH.JOURNAL_SDOT_TEST_VIEW,
                children: [
                  {
                    element: <JournalSdotTestView />,
                    index: true,
                  },
                ]
              }
            ]
          },
        ]
      },
      {
        path: ROUTE_PATH.SCHEDULE,
        element: <Schedule />,
      },
      {
        path: ROUTE_PATH.STUDENTS_SCHEDULE,
        children: [
          {
            element: <StudentSchedule />,
            index: true,
          },
          {
            path: ROUTE_PATH.STUDENTS_SCHEDULE_PLAN,
            children: [
              {
                element: <ScheduleStudentPlan />,
                index: true,
              },
              {
                path: ROUTE_PATH.STUDENTS_SCHEDULE_PLAN_TEST,
                children: [
                  {
                    element: <ScheduleStudentTest />,
                    index: true,
                  },
                  {
                    path: ROUTE_PATH.STUDENTS_SCHEDULE_PLAN_TEST_VIEW,
                    element: <ScheduleStudentTestView />
                  }
                ]
              }
            ]
          }
        ],
      },
      {
        path: ROUTE_PATH.RECORD,
        element: <Record />,
      },
      {
        path: ROUTE_PATH.PLANS,
        children: [
          {
            element: <Plans />,
            index: true,
          },
          {
            path: ROUTE_PATH.PLANS_VIEW,
            children: [
              {
                element: <PlansView />,
                index: true,
              },
              {
                path: ROUTE_PATH.LESSON_VIEW,
                children: [
                  {
                    element: <LessonView />,
                    index: true
                  },
                  {
                    path: ROUTE_PATH.LESSON_TEST,
                    children: [
                      {
                        element: <Test />,
                        index: true
                      },
                      {
                        path: ROUTE_PATH.LESSON_TEST_VIEW,
                        element: <TestView />
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },


      //entrant
      {
        path: ROUTE_PATH.ENTRANT_PROFESSIONAL_ORIENTATION_TEST,
        element: <ProfessionalOrientationTest />,
      },
      {
        path: ROUTE_PATH.ENTRANT_ADMISSION,
        element: <EntrantApplicationPage />
      },
      {
        path: ROUTE_PATH.ENTRANT_ADMISSION_WITHOUT_RANKING,
        element: <EntrantAdmissionWithoutRanking />
      },
      {
        path: ROUTE_PATH.ENTRANT_ADMISSION_ACCEPT_REJECT,
        element: <AdmissionAcceptRejectNote />
      },
      {
        path: ROUTE_PATH.ENTRANT_ADMISSION_ACCEPT_REJECT_NOTE,
        element: <AdmissionNotes />
      },
      {
        path: ROUTE_PATH.ENTRANT_ADMISSION_VIEW,
        element: <AdmissionView />
      },
      {
        path: ROUTE_PATH.ENTRANT_ADMISSION_LOG,
        element: <AdmissionLog />
      },
      {
        path: ROUTE_PATH.ENTRANT_EDUCATION_ORDERS,
        element: <EducationOrders />
      },
      {
        path: ROUTE_PATH.MEDICAL_ROOM,
        children: [
          {
            element: <MedicalRoom />,
            index: true
          },
          {
            path: ROUTE_PATH.MEDICAL_ROOM_APPEAR_VIEW,
            element: <AppealsView />
          }
        ]
      },
      {
        path: ROUTE_PATH.ENTRANT_USER_APPLICATIONS,
        children: [
          {
            element: <UserApplications />,
            index: true
          },
          {
            path: ROUTE_PATH.ENTRANT_USER_APPLICATIONS_CURRENT,
            element: <UserApplicationsCurrent />
          }
        ]
      },
      {
        path: ROUTE_PATH.PSYCHOLOGIST,
        children: [
          {
            index: true,
            element: <PsychologistRoom />
          },
          {
            path: ROUTE_PATH.PSYCHOLOGIST_VIEW,
            element: <PsychologistView />
          },
          {
            path: ROUTE_PATH.PSYCHOLOGIST_WORK_VIEW,
            element: <PsychologistWorkSubView />
          }
        ]
      }
    ]
  },
]

const publicRoutesArr: RouteObject[] = [
  {
    element: <PublicLayout />,
    children: [
      {
        path: ROUTE_PATH.AUTH,
        element: <Auth />,
      },
      {
        path: ROUTE_PATH.RESTORE,
        element: <Restore />,
      },
      {
        path: ROUTE_PATH.ENTRANT_REGISTER,
        element: <EntrantRegister />
      },
      {
        path: ROUTE_PATH.ENTRANT_INFO,
        element: <EntrantInfo />
      }
    ],
  },
]

const defaultProtectedArr: RouteObject[] = [
  {
    element: <DefaultProtectedLayout />,
    children: [
      {
        path: ROUTE_PATH.RUP,
        children: [
          {
            element: <Rup />,
            index: true,
          },
          {
            path: ROUTE_PATH.RUP_QUALIFICATION,
            children: [
              {
                element: <QualificationRup />,
                index: true,
              },
              {
                path: ROUTE_PATH.RUP_QUALIFICATION_TABLE,
                children: [
                  {
                    element: <TableRup />,
                    index: true
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        path: ROUTE_PATH.USER_ORDER_LEAVE,
        element: <LeaveUserOrder />
      }
    ]
  },
]

export const ROUTES_CONFIG: RouteObject[] = [
  {
    element: <RootLayout />,
    loader: async ({ params }) => {
      // console.log('loader', {params: params})
      return null
    },
    action: async ({ params, request }) => {
      // console.log('action', {params, request})
      return null
    },
    children: [
      ...publicRoutesArr,
      ...protectedRoutesArr,
      ...defaultProtectedArr
    ]
  }
]
